import {ChangeDetectionStrategy, Component, HostBinding, Input} from "@angular/core";
import {MatIconModule} from "@angular/material/icon";

@Component({
               selector       : "cs-icon",
               templateUrl    : "./icon.component.html",
               styleUrls      : ["./icon.component.scss"],
               imports        : [MatIconModule],
               changeDetection: ChangeDetectionStrategy.OnPush
           })
export class IconComponent
{
    @Input() csIcon: string;
    @Input() icon: string;
    @Input() svgIcon: string;
    @Input() @HostBinding("style.font-size.px") fontSize: number;
}
